import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-131">
      <FadeIn data-id="element-132">
        <div className="bg-[#020617] rounded-[2.5rem] p-8 md:p-16 border border-[#22c55e]/30 shadow-[0_20px_50px_rgba(2,6,23,0.15)] relative overflow-hidden" data-id="element-133">
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#22c55e_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-134"></div>

          <div className="relative z-10" data-id="element-135">
            <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-[#e2e8f0] text-[28px]" data-id="element-136">
              El sistema no es magia. Es el orden correcto de las cosas
              correctas. 💰
            </h2>

            <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-137">
              {/* Option 1 */}
              <a href="https://tumanualdigital.com/cart/44209846878244:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-[#0f172a] border border-[#22c55e]/30 rounded-2xl hover:border-[#22c55e] transition-colors group pt-[0px] pb-[0px]" data-id="element-138">
                <div className="text-left mb-4 sm:mb-0" data-id="element-139">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-140">
                    <span data-id="element-141">📘</span> SISTEMA ESCAPISTA PRO
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-142">
                    <span className="text-[#ef4444] line-through text-sm font-bold" data-id="element-143">
                      $200.000
                    </span>
                    <span className="text-2xl font-black text-white" data-id="element-144">
                      $19.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#1e293b] text-[#22c55e] font-black py-3 px-6 rounded-xl group-hover:bg-[#334155] transition-colors w-full sm:w-auto text-center border border-[#22c55e]/30" data-id="element-145">
                  → QUIERO MI SISTEMA ESCAPISTA PRO
                </div>
              </a>

              {/* Option 2 */}
              <a href="https://tumanualdigital.com/cart/44209847009316:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-[#C9A84C]/20 to-[#0f172a] border-2 border-[#C9A84C] rounded-2xl hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all group relative overflow-hidden" data-id="element-146">
                <div className="absolute top-0 right-0 bg-[#C9A84C] text-[#020617] text-xs font-black px-3 py-1 rounded-bl-lg" data-id="element-147">
                  ⭐ MÁS ELEGIDO
                </div>
                <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-148">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-149">
                    <span data-id="element-150">🏆</span> SISTEMA ESCAPISTA PRO + EL ACELERADOR
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-151">
                    <span className="text-[#ef4444] line-through text-sm font-bold" data-id="element-152">
                      $280.000
                    </span>
                    <span className="text-2xl font-black text-[#C9A84C]" data-id="element-153">
                      $27.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#C9A84C] text-[#020617] font-black py-3 px-6 rounded-xl group-hover:bg-[#b8924a] transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-154">
                  → QUIERO EL SISTEMA + EL ACELERADOR
                </div>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-[#e2e8f0] font-bold" data-id="element-155">
              <span className="flex items-center gap-1.5" data-id="element-156">
                <Lock size={16} className="text-[#22c55e]" data-id="element-157" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-158">
                <Zap size={16} className="text-[#22c55e]" data-id="element-159" /> Acceso en 5 min
              </span>
              <span className="flex items-center gap-1.5" data-id="element-160">
                <Shield size={16} className="text-[#22c55e]" data-id="element-161" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-[#475569] font-medium" data-id="element-162">
              <span className="flex items-center gap-1.5" data-id="element-163">
                <CreditCard size={16} data-id="element-164" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}